module.exports = __webpack_public_path__ + "static/media/26.c87636e9.png";